import { useSharedCheckoutContext } from '@root/components/checkout/context';
import { PLANS } from '@root/constants/pricing';

export const useStoragePlanInfo = () => {
  const {
    flowState: { values },
    pricingSummary,
  } = useSharedCheckoutContext();
  const { planSize } = values;

  if (!pricingSummary || !planSize) return null;

  return {
    label: PLANS[planSize].label,
    amount: pricingSummary.monthlyAmount,
  };
};
